const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

if (!window.CartPerformance) {
  window.CartPerformance = class CartPerformance {
    static metric_prefix = 'cart-performance';

    static createStartingMarker(benchmarkName) {
      try {
        const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
        return performance.mark(`${metricName}:start`);
      } catch (e) {
        return null;
      }
    }

    static measureFromEvent(benchmarkName, event) {
      try {
        const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
        performance.mark(`${metricName}:start`, {
          startTime: event?.timeStamp || Date.now()
        });
        performance.mark(`${metricName}:end`);
        performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
      } catch (e) {}
    }

    static measureFromMarker(benchmarkName, startMarker) {
      try {
        if (!startMarker) return;
        const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
        performance.mark(`${metricName}:end`);
        performance.measure(metricName, startMarker ? startMarker.name : `${metricName}:start`, `${metricName}:end`);
      } catch (e) {}
    }

    static measure(benchmarkName, callback) {
      if (typeof callback === 'function') {
        try {
          const metricName = `${CartPerformance.metric_prefix}:${benchmarkName}`;
          performance.mark(`${metricName}:start`);
          callback();
          performance.mark(`${metricName}:end`);
          performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
        } catch (e) {
          callback();
        }
      }
    }
  };
}

